module.exports = __webpack_public_path__ + "img/s21.5e2c5e28.png";